module.exports = __webpack_public_path__ + "img/background-menus.3f63c239.png";